import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import Spec from '../../../../models/Spec';
import { SpecPaper } from '../../../../components/Paper';
import AdminLayout from '../../../../layouts/AdminLayout';

interface Props extends RouteComponentProps<{ spec_name: string }> { }

const SpecView = (props: Props) => {
  const { spec_name } = props.match.params;
  const [spec, setSpec] = useState<Spec>(new Spec());
  const [existingSpecList, setExistingSpecList] = useState<Spec[]>([]);
  const [isLoadingSpec, setIsLoadingSpec] = useState(true);

  const retrieveSpec = async () => {
    try {
      setIsLoadingSpec(true);
      const specs = await Spec.fetchList();
      setExistingSpecList(specs);

      const data = (() => {
        for (let item of specs) {
          if (item.id === spec_name) {
            return item;
          }
        }
        return new Spec();
      })();
      data.assignmentOrderIndex = undefined;
      setSpec(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingSpec(false);
    }
  };

  const handleSpecDelete = () => {
    setSpec(new Spec());
  };

  const handleSpecSaved = (savedSpec: Spec) => {
    setExistingSpecList(existingSpecList.map(item => {
      if (item === spec) return savedSpec;
      return item;
    }));
    setSpec(savedSpec);
  };

  useEffect(() => {
    (async () => {
      await retrieveSpec();
    })();
  }, []);

  return (
    <AdminLayout>
      <div className="py-2">
        <SpecPaper
          spec={spec}
          existingSpecList={existingSpecList}
          onDeleteSpec={handleSpecDelete}
          onSpecSaved={handleSpecSaved}
          isLoading={isLoadingSpec}
        />
      </div>
    </AdminLayout>
  );
};

export default SpecView;
